/* eslint func-names: ["off"] */
/* eslint prefer-arrow-callback: ["off"] */

import Vue from 'vue';
import VueForm from 'vue-form';
import VCalendar from 'v-calendar';
import 'jquery-address';
import 'owl.carousel/dist/owl.carousel';
import '@situation/setdesign.common';
import '@situation/setdesign.directives.owl-a11y';
import '@situation/setdesign.directives.sticky-header';
import '@situation/setdesign.directives.toggle';
import '@situation/setdesign.nav-menu';
import '@situation/setdesign.modal';
import '@situation/setdesign.video';
import '@situation/setdesign.tag-manager';
import '@situation/setdesign.read-more';
import '@situation/setdesign.accordion';
import '@situation/setdesign.sub-nav';
import '@situation/setdesign.filters';
import '@situation/setdesign.media-carousel';
import '@situation/setdesign.responsive-picture';
import '@situation/setdesign.lazy-image';
import '@situation/setdesign.message';
import '@situation/vc-library';
import {
    $, addAction, INIT, importAll, registerVueComponents,
} from '@situation/setdesign.util';
import Swiper from 'swiper';
import Readmore from 'readmore-js';
import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';

importAll(require.context('../images', true));
importAll(require.context('../fonts', true));
importAll(require.context('./components', false));
importAll(require.context('./components/show-filters', false));
addAction(INIT, () => {
    const VUE_APP_ID = '#app';
    if (!$(VUE_APP_ID).length) {
        return;
    }

    Vue.use(VueForm);
    Vue.use(VCalendar);
    registerVueComponents(require.context('./components/inquiry-form', false), Vue);
    registerVueComponents(require.context('./components/calendar', false), Vue);
    Vue.filter('monthToString', (value) => {
        const monthNames = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ];
        return monthNames[value - 1];
    });

    new Vue({}).$mount(VUE_APP_ID);
});

$(function () {
    // --- Venue Listing Card Element Height Normalization ---
    if ($('.venue-listing__grid .theatre-card').length) {
        // Find all unique .theatre-card__* classes
        const cardEls = $('.venue-listing__grid .theatre-card');
        const classSet = new Set();
        cardEls.each(function () {
            $(this).find('[class*="theatre-card__"]').each(function () {
                const classes = $(this).attr('class').split(/\s+/);
                classes.forEach((cls) => {
                    if (cls.startsWith('theatre-card__')) {
                        classSet.add(cls);
                    }
                });
            });
        });

        // For each unique .theatre-card__X class, set all to the max height
        classSet.forEach((cls) => {
            const $elems = $('.venue-listing__grid .' + cls);
            let maxHeight = 0;
            $elems.css('height', ''); // Reset first
            $elems.each(function () {
                const h = $(this).outerHeight();
                if (h > maxHeight) maxHeight = h;
            });
            $elems.css('height', maxHeight + 'px');
        });
    }

    $('.search-toggle').click(function () {
        const $this = $(this);

        $('#search-overlay').toggle();
        $this.find('.search-icon').toggle();
        $this.find('.close-icon').toggle();
    });

    $('.mobile-menu-toggle').click(function () {
        $('#mobile-nav').toggle();
        // Toggle the search toggle button and the menu button and show the 'X'
        $('#header-primary-menu').toggle();
        $('#mobile-menu-close-button').toggle();
        // Stop the body of the page from scrolling
        $('body').toggleClass('overflow-hidden');
    });

    $('#more-toggle').click(function () {
        $('#more-submenu').toggle();
        $(this).find('.fa-angle-down').toggleClass('fa-rotate-180');
    });

    $('#mobile-more-toggle').click(function () {
        $('#mobile-more-menu').toggle();
        $(this).find('.fa-angle-down').toggleClass('fa-rotate-180');
    });

    // Local Image replacement---------------------------------------------------------------------
    function replaceImageDomains() {
        // Get all image elements in the document using jQuery.
        $('img').each(function () {
            const $img = $(this);
            const originalSrc = $img.attr('src');
            if (originalSrc) {
                // Use a regular expression to replace the domain, keeping the relative path.
                const newSrc = originalSrc.replace(/^https?:\/\/(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?:\/|$)/i, 'https://groups.broadway.com/');
                // Update the image source using jQuery's attr() method.
                $img.attr('src', newSrc);
            }
        });
    }
    replaceImageDomains();

    // Show page Photo/Video Gallery---------------------------------------------------------------
    var gallerySwiper = new Swiper(".gallery-swiper", {
        slidesPerView: 1,
        spaceBetween: 20,
        slidesPerGroup: 1,
        loop: false,
        navigation: {
            nextEl: '.carousel-container #swiper-button-next',
            prevEl: '.carousel-container #swiper-button-prev',
        },
        breakpoints: {
            768: { slidesPerView: 3, spaceBetween: 20, slidesPerGroup: 1 },
            1024: { slidesPerView: 4, spaceBetween: 20, slidesPerGroup: 1 }
        },
        on: {
            // Initialize lightGallery after Swiper is fully initialized
            init: function () {
                const galleryContainer = document.getElementById('lightgallery');
                if (galleryContainer) {
                    if (typeof lightGallery === 'function') {
                        const pluginsToUse = [];
                        if (typeof lgVideo === 'function') pluginsToUse.push(lgVideo);

                        lightGallery(galleryContainer, {
                            plugins: pluginsToUse,
                            selector: 'a.swiper-slide',
                            speed: 500,
                            download: false,
                            counter: true,
                        });
                    } else {
                        // console.error('lightGallery is not defined.');
                    }
                } else {
                    // console.error('lightGallery container not found for init within Swiper!');
                }
            }
        }
    });

    // YouTube iframe loading fix
    const checkAndModifyIframe = function(iframe) {
        if (iframe.src && iframe.src.includes('youtube')) {
            iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');

            // We reset the src to itself to force reload with new referrer policy.
            // We assign to a variable to get around linter policy.
            let src = iframe.src + '';

            // eslint-disable-next-line no-param-reassign
            iframe.src = src;
        }
    };

    const targetNode = document.body;
    const config = {
        childList: true,
        subtree: true
    };

    const callback = function(mutationsList, observer) {
        mutationsList.forEach((mutation) => {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeName === 'IFRAME') {
                        checkAndModifyIframe(node);
                    }
                    if (node.nodeType === 1) { // 1 is Element node
                        $(node).find('iframe').each(function() {
                            checkAndModifyIframe(this);
                        });
                    }
                });
            }
        });
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);

    // Show page Event Calendar-------------------------------------------------------------------
    const $progressBar = $('#swiper-progress-bar');
    const $calendarIcon = $('#timeline-calendar-icon');
    const $progressBarContainer = $('#progress-bar-container');
    let calendarSwiper;

    // Read the initial slide index from the hidden field
    let initialSlideIndex = 0; // Default to 0
    const initialIndexValue = $('#swiper-initial-slide-index').val();
    if (initialIndexValue) {
        initialSlideIndex = parseInt(initialIndexValue, 10) || 0;
    }

    let isDragging = false;
    let initialX;
    let initialIconLeftPercent;

    function updateUIFromSwiperProgress(swiperInstance) {
        let currentProgress = swiperInstance.progress;
        if (currentProgress < 0) currentProgress = 0;
        if (currentProgress > 1) currentProgress = 1;

        const progressPercentage = currentProgress * 100;

        if (!$progressBar.hasClass('dragging')) {
            $progressBar.css('width', progressPercentage + '%');
        }
        if (!$calendarIcon.hasClass('dragging')) {
            $calendarIcon.css('left', progressPercentage + '%');
        }
    }

    calendarSwiper = new Swiper('.performance-swiper', {
        initialSlide: initialSlideIndex,
        slidesPerView: 1,
        spaceBetween: 10,
        slidesPerGroup: 1,
        speed: 300,
        breakpoints: {
            768: { slidesPerView: 4, spaceBetween: 10, slidesPerGroup: 1 },
            1024: { slidesPerView: 6, spaceBetween: 10, slidesPerGroup: 1 }
        },
        on: {
            init: function (s) {
                updateUIFromSwiperProgress(s);
            },
            progress: function (s, progressValue) {
                if (!isDragging) {
                    updateUIFromSwiperProgress(s);
                }
            },
            slideChangeTransitionEnd: function (s) {
                updateUIFromSwiperProgress(s);
            },
            touchEnd: function(s) {
                if (!isDragging) {
                    updateUIFromSwiperProgress(s);
                }
            }
        }
    });

    // Custom Navigation Listeners
    $('#perf-cal-button-next').on('click', function() {
        if (calendarSwiper) {
            calendarSwiper.slideNext();
        }
    });

    $('#perf-cal-button-prev').on('click', function() {
        if (calendarSwiper) {
            calendarSwiper.slidePrev();
        }
    });

    function dragStart(e) {
        isDragging = true;
        $calendarIcon.addClass('dragging');
        $progressBar.addClass('dragging');

        // Use originalEvent for touch properties if e is a jQuery event object
        const originalEvent = e.originalEvent || e;
        initialX = originalEvent.type === 'touchstart' ? originalEvent.touches[0].clientX : originalEvent.clientX;

        const containerRect = $progressBarContainer[0].getBoundingClientRect();
        const iconRect = $calendarIcon[0].getBoundingClientRect();
        let currentIconLeftPx = iconRect.left - containerRect.left + (iconRect.width / 2);
        initialIconLeftPercent = (currentIconLeftPx / containerRect.width) * 100;

        e.preventDefault();

        $(document).on('mousemove.drag', dragMove); // Namespace event for easier removal
        $(document).on('mouseup.drag', dragEnd);
        $(document).on('touchmove.drag', function(event) { // Wrap to access originalEvent for touches
            dragMove(event.originalEvent || event);
        });
        $(document).on('touchend.drag', dragEnd);
    }

    function dragMove(e) { // e might be a native event from touchmove
        if (!isDragging) return;
        e.preventDefault();

        const currentX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
        const dx = currentX - initialX;

        const containerWidth = $progressBarContainer.width(); // jQuery width()
        const dxPercent = (dx / containerWidth) * 100;

        let newProgressPercent = initialIconLeftPercent + dxPercent;

        if (newProgressPercent < 0) newProgressPercent = 0;
        if (newProgressPercent > 100) newProgressPercent = 100;

        $calendarIcon.css('left', newProgressPercent + '%');
        $progressBar.css('width', newProgressPercent + '%');

        calendarSwiper.setProgress(newProgressPercent / 100, 0);
    }

    function dragEnd() {
        if (!isDragging) return;

        isDragging = false;

        $calendarIcon.removeClass('dragging');
        $progressBar.removeClass('dragging');

        $(document).off('.drag'); // Remove all namespaced drag events

        calendarSwiper.update();
        calendarSwiper.slideToClosest(calendarSwiper.params.speed);
    }

    $calendarIcon.on('mousedown touchstart', dragStart);

    // Hero Carousel--------------------------------------------------------------------------------
    $('.carousel-item', '.show-neighbors').each(function () {
        const $this = $(this);
        let $next = $this.next();

        if (!$next.length) {
            $next = $this.siblings(':first');
        }

        $next.children(':first-child')
            .clone()
            .appendTo($this)
            .find('.container')
            .addClass('no-margin-left');
    }).each(function () {
        const $this = $(this);
        let $prev = $this.prev();

        if (!$prev.length) {
            $prev = $this.siblings(':last');
        }

        $prev.children(':nth-last-child(2)')
            .clone()
            .prependTo($this)
            .find('.container')
            .addClass('no-margin-right');
    });

    // Readmore-js initialization------------------------------------------------------------------
    $('.readmore').readmore({
        moreLink: '<a class="morelink" href="#">Read More</a>',
        lessLink: '<a class="lesslink" href="#">Read Less</a>',
        collapsedHeight: 117,
    });
});
